var DROPDOWN_VARIANT = {
  BASIC: 'basic',
  BASIC_LINE: 'basic_line',
  BASIC_LINE_DASHED: 'basic_line_dashed'
};
var OPTION_HEIGHT = 44;
var LISTBOX_MAX_HEIGHT = 220;

export { DROPDOWN_VARIANT, LISTBOX_MAX_HEIGHT, OPTION_HEIGHT };
